import React, { Component } from 'react';
import API from '../services/api';
import './ProfileList.css';
import AuthService from '../services/auth';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withAuthorization  from './withAuthorization';

class Last2WeeksUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profiles: [],
    }
  }

  componentDidMount() {
    if(!AuthService.isLoggedIn()) {
      window.location = '/';
    }
    const { ucdUser } = this.props;
    if(!['admin', 'Hansel', 'Richard '].includes(ucdUser.name)) {
      window.location = '/';
    }

    (new API()).get('/users/last-two-weeks' ,{}, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          profiles: response,
        });
      });
  }

  approveUser(id) {
    (new API()).post(`/users/${id}/update-status` ,{status: 0}, AuthService.getAuthCookie())
      .then(() => {
        let { profiles } = this.state;
        profiles = profiles.filter((el) => {
          return el.id !== id;
        });
        this.setState({ profiles });
      });
  }

  render() {
    const { profiles } = this.state;
    return (
      <div className="row profile-list">
        <div className="col col-12" style={{fontSize: '5rem'}}>
          Last 2 Weeks
        </div>
        {profiles && profiles.map(profile => (
          <div key={profile.name} className="profile col col-6 col-md-3">
            <div className="image" style={{backgroundImage: `url('${profile.photo_url}')`}} />
            <button
              className="button"
              onClick={() => {this.approveUser(profile.id);}}
            >
              Disapprove {profile.name}
            </button>
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return({
    ucdUser: state.sessionState.ucdUser,
  });};

const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition), connect(mapStateToProps))(Last2WeeksUsers);


// WEBPACK FOOTER //
// ./src/components/Last2WeeksUsers.js